import requests from "./httpService";

const WebSliderServices = {

    getWebSlider: async () => {
        return requests.get(`/advertisement`);
    },
    updateWebSlider: async (id, body) => {
        return requests.patch(`/advertisement/${id}`, body);
    },

    createWebSlider: async (body) => {
        return requests.post(`/advertisement`, body);
    },

    deleteWebSlider: async (id) => {
        return requests.delete(`/advertisement/${id}`);
    },
    updateBanner: async (id, body) => {
        return requests.patch(`/advertisement/${id}`, body)
    },
    getBanner: async () => {
        return requests.get(`/advertisement`)
    },
    createBanner: async (body) => {
        return requests.post(`/advertisement`, body)
    },
    deleteBanner: async (id) => {
        return requests.delete(`/advertisement/${id}`)
    }
}

export default WebSliderServices;

